import { TOnboardingTabStatus } from "../../components/Front/Simple/FrontOnboardingTab/FrontOnboardingTab";

type TStepWithStatus = {
    status: TOnboardingTabStatus;
};

export const isOnboardingComplete = (steps: Array<TStepWithStatus>): boolean =>
    steps.length > 0
    && steps.every((step) => step.status === "completed");
